import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IconButtonComponent } from '../../button';
import { IconComponent } from '../../icon';
import { ProgressBarComponent, ProgressBarModel } from '../../progress-bar/progress-bar.component';

@Component({
  selector: 'sb-checklist-minimized',
  templateUrl: './checklist-minimized.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconComponent, IconButtonComponent, ProgressBarComponent, RouterModule],
})
export class ChecklistMinimizedComponent {
  @HostBinding('class')
  public baseClass = 'absolute bottom-20 z-50';

  @Input({ required: true })
  public title!: string;
  @Input({ required: true })
  public progress!: ProgressBarModel;

  @Output()
  public clicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  public closed: EventEmitter<void> = new EventEmitter<void>();

  public onMaximize() {
    this.clicked.emit();
  }

  public onClose(event: MouseEvent) {
    event.stopPropagation();
    this.closed.emit();
  }
}
